/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetPresignedUrlRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/utility_messages.pb'
import {GetPresignedUrlResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/utility_messages.pb'


export const getPresignedUrl = (request:GetPresignedUrlRequest, options?: CashRequestOptions) => post<GetPresignedUrlRequest, GetPresignedUrlResponse>("/2.0/cash/get-presigned-url", request, {...options, rejectOnError: true })